import React, { useState } from "react";
import { HiOutlineMenu } from "react-icons/hi";
import { FaFingerprint, FaUser } from "react-icons/fa";
import { Link, NavLink } from 'react-router-dom';
import { MdClose } from "react-icons/md";
import Popuplogo from "../../assets/images/logo_icon.png";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { apiCall, getCurrentUser } from "../../Api/auth";
import "./Header.css";
import { useEffect } from "react";
import { API_URL } from "../../Api/config";
import { BsGrid, BsPower } from "react-icons/bs";
import { FiChevronDown } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { logout } from "../../Api/auth";
import SupportPopup from "../SupportPopup/SupportPopup";
import RemoateFitting from "../RemoateFitting/RemoateFitting";
import { addStaff } from "../../Api/staff";
import { getcountriesforfitter, getstates, getcities, } from '../../Api/iron'


function Header({ loginusercallback, showremotefittingpopup }) {

    const [password, setPassword] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [apicall, setApicall] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const [userdata, setUserdata] = React.useState(null);

    const [successmsg, setSuccessmsg] = React.useState('');

    useEffect(() => {
        // setUserdata(getCurrentUser());
        const fetchUserData = async () => {
            try {
                const userData = await getCurrentUser();
                if (userData) {
                    setUserdata(userData);
                } else {
                    // Handle case where user data is missing or incomplete
                    console.error('User data is missing or incomplete.');
                }
            } catch (error) {
                // Handle any errors that occur during data fetching
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();
        getallcountry();
    }, []);

    useEffect(() => {
        // setUserdata(getCurrentUser());
        if (loginusercallback !== null) {
            const fetchUserData = async () => {
                try {
                    const userData = await getCurrentUser();
                    if (userData) {
                        setUserdata(userData);
                    } else {
                        // Handle case where user data is missing or incomplete
                        console.error('User data is missing or incomplete.');
                    }
                } catch (error) {
                    // Handle any errors that occur during data fetching
                    console.error('Error fetching user data:', error);
                }
            };

            fetchUserData();
        }
    }, [loginusercallback]);

    const toggle = () => {
        document.getElementById("navbar").classList.toggle("navbar-mobile");
        if (document.getElementById("navbar").classList.contains("navbar-mobile")) {
            document.getElementsByClassName("menu-icon")[0].style.display = "none";
            document.getElementsByClassName("close-icon")[0].style.display = "block";
        }
        else {
            document.getElementsByClassName("menu-icon")[0].style.display = "block";
            document.getElementsByClassName("close-icon")[0].style.display = "none";
        }

    }

    const getErrorByField = (errors, field) => {
        return errors.filter(function (item) {
            if (item.field === field) { return { "field": item.field, "message": item.message } }
        });
    }

    const [show, setShow] = useState(false);
    const [validated, setValidated] = useState(false);

    const handleSubmit = async (event) => {
        setApicall(true);
        apiCall(API_URL + "user/login", "POST", { email: email, password: password }, event).then((res) => {
            if (!res.data.status) { setErrors(res.data.error); }
            else {
                localStorage.setItem("user", JSON.stringify(res.data.data));
                const role_id = res.data.data.user.role_id;
                // window.location.href = "/dashboard"
                if (role_id === 4) {
                    window.location.href = "/user-dashboard"
                } else if (role_id === 1) {
                    window.location.href = "/fitter-dashboard"
                } else if (role_id === 8) {
                    window.location.href = "/fitter-builder-dashboard"
                } else if (role_id === 7) {
                    window.location.href = "/builder-dashboard"
                } else if (role_id === 10) {
                    window.location.href = "/fitter-dashboard"
                }
                else {
                    window.location.href = "/dashboard"
                }
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    }


    const forgetpassword = async (event) => {
        setApicall(true);
        apiCall(API_URL + "user/forgetpassword", "POST", { email: email }, event).then((res) => {
            if (!res.data.status) { setErrors(res.data.error); }
            else {
                setSuccessmsg("Please check your E-mail for link");
                // localStorage.setItem("user", JSON.stringify(res.data.data));
                // const role_id = res.data.data.user.role_id;
                // window.location.href = "/dashboard"
                // if (role_id === 4) {
                //     window.location.href = "/user-dashboard"
                // } else {
                //     window.location.href = "/dashboard"
                // }
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    useEffect(() => {
        console.log("getCurrentUser", getCurrentUser());
    }, [errors]);

    // const userData = localStorage.getItem("user");
    // const userJson = JSON.parse(userData);

    // const roleId = userJson.user?.role_id

    const userData = localStorage.getItem("user");
    let roleId;
    if (userData) {
        const userJson = JSON.parse(userData);

        roleId = userJson.user?.role_id
    } else {
        roleId = null
    }



    const toggleLable = () => {
        document.getElementsByClassName("sec-center")[0].classList.toggle("show");
    }

    const [scrolling, setScrolling] = useState(false);
    const [scrollTop, setScrollTop] = useState(0);

    const handleScroll = () => {
        setScrollTop(document.documentElement.scrollTop);
        setScrolling(document.documentElement.scrollTop > 100);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrollTop]);

    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);


    const [show02, setShow02] = useState(false);
    const handleClose02 = () => setShow02(false);
    const handleShow02 = () => setShow02(true);


    const handleShowForm = (newFormShowValue) => {
        setShow02(newFormShowValue);
        handleClose(newFormShowValue);
        handleClose03(newFormShowValue);
    };

    const [show03, setShow03] = useState(false);
    const handleClose03 = () => setShow03(false);
    const handleShow03 = () => setShow03(true);


    const [showfitter, setShowfitter] = useState(false);
    const handleClosefitter = () => setShowfitter(false);
    const handleShowfitter = () => setShowfitter(true);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [phone, setPhone] = useState("");
    const [website, setWebsite] = useState("");
    const [shippingAddress, setShippingAddress] = useState("");

    const [serverSideError, setServerSideError] = useState(null);

    const [apiCallNew, setAPICallNew] = useState(false);

    //new code
    const [country_id, setCountry_id] = useState('');
    const [state_id, setState_id] = useState('');
    const [city_id, setCity_id] = useState('');
    const [zipcode, setzipcode] = useState('');
    const [bio, setbio] = useState('');


    const [countrylist, setCountrylist] = useState([]);
    const [statelist, setStatelist] = useState([]);
    const [citylist, setCitylist] = useState([]);

    const [stateLoading, setStateLoading] = useState(false);
    const [cityLoading, setCityLoading] = useState(false);


    const handleSubmit2 = (event) => {
        setAPICallNew(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setAPICallNew(false);
        } else {
            event.preventDefault();

            const data = {
                firstname: firstName,
                lastname: lastName,
                business_name: businessName,
                phone: phone,
                email: email,
                website_url: website,
                shipping_address: shippingAddress,
                role_id: 9,
                password: "12345678",
                confirmPassword: "12345678",
                country: country_id,
                state: state_id,
                city: city_id,
                zip: zipcode,
                bio: bio,
            };

            addStaff(data).then((res) => {
                console.log(res);
                if (!res.data.status) {
                    console.log("res.data.error", res.data.error);
                    setServerSideError(res.data.error);
                } else {
                    handleClosefitter();
                    setFirstName("");
                    setLastName("");
                    setBusinessName("");
                    setPhone("");
                    setEmail("");
                    setWebsite("");
                    setShippingAddress("");
                    setServerSideError(null);
                    setValidated(false);
                    // window.location.href = "/user-dashboard";

                    setCountry_id('');
                    setState_id('');
                    setCity_id('');
                    setzipcode('');
                    setbio('');
                    setStatelist([]);
                    setCitylist([]);
                }
            }).catch((err) => {
                // alert(err);
                console.log(err);
            }).finally(() => {
                setAPICallNew(false);
                // setValidated(false);
            });
        }


        setValidated(true);
    }


    const getallcountry = () => {
        getcountriesforfitter()
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    const data = response.data.data;
                    setCountrylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallstatefunc = (country_id) => {
        setStateLoading(true)
        const data = {
            country_id: country_id,
        };
        getstates(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    setStateLoading(false)
                    const data = response.data.data;
                    setStatelist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallcityfunc = (state_id) => {
        setCityLoading(true);
        const data = {
            state_id: state_id,
        };
        getcities(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    setCityLoading(false);
                    const data = response.data.data;
                    setCitylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };


    return (
        <>
            <header id="header" className="header fixed-top menu container-fluid container-xxl">
                <div className="d-flex align-items-center justify-content-between">
                    <a href="/about-us" className="logo d-flex align-items-center">
                        <span><img src={require("../../assets/images/logo_icon.png")} /></span>
                    </a>
                    <div id="menu-center" className="hide_mobile">
                        <ul className="nav nav_center desk-nav">
                            <li className>
                                <NavLink to="/club-fitting" activeClassName="active" className="btn cen_men nav_club_fitting">Club Fitting</NavLink>
                            </li>
                            <li className>
                                <NavLink to="/golf-clubs" activeClassName="active" className="btn cen_men nav_golf_lessons">Golf Clubs</NavLink>
                            </li>

                            <li className>
                                <NavLink to="/about-us" exact activeClassName="active" className="btn cen_men nav_footer">About us</NavLink>
                            </li>
                            <li className>
                                <NavLink to="/fitter/fitter-locator" exact activeClassName="active" className="btn cen_men nav_footer">Find a Fitter</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="header_in_area">
                        {
                            userdata === null ?
                                (
                                    <div className="nav_login">
                                        <button className="nav-link" onClick={handleShow}><FaUser className="me-2" /> Sign in</button>
                                    </div>
                                ) : (
                                    <div className="sec-center">
                                        <label className="for-dropdown profile-btn-view" htmlFor="dropdown" onClick={toggleLable}>
                                            {/* <div className="user-image"> <img src={require('../../assets/images/Avatar.png')} className="img-responsive modal_profile_img2" /></div> */}
                                            <span className="user-name m-0">{userdata?.user?.firstname}</span>
                                            <FiChevronDown />
                                        </label>
                                        <div className="section-dropdown dropdown-menu-item">
                                            {/* {
                                                roleId == "4" ?
                                                    <a className="dropdown-item memu-drop-item" href="/user-dashboard"><BsGrid /> Dashboard</a>
                                                    :
                                                    <a className="dropdown-item memu-drop-item" href="/dashboard"><BsGrid /> Dashboard</a>
                                            }
                                            {
                                                roleId == "1" ?
                                                <a className="dropdown-item memu-drop-item" href="/fitter-dashboard"><BsGrid /> Dashboard</a>
                                                :
                                                <a className="dropdown-item memu-drop-item" href="/dashboard"><BsGrid /> Dashboard</a>
                                            } */}
                                            {/* <a className="dropdown-item memu-drop-item" href={roleId === "4" ? "/user-dashboard" : roleId === 1 ? "/fitter-dashboard" : "/dashboard"}>
                                                <BsGrid /> Dashboard
                                            </a> */}
                                            <a className="dropdown-item memu-drop-item" href={
                                                roleId === 4 ? "/user-dashboard" :
                                                    roleId === 1 ? "/fitter-dashboard" :
                                                        roleId === 8 ? "/fitter-builder-dashboard" :
                                                            roleId === 7 ? "/builder-dashboard" :
                                                                roleId === 10 ? "/fitter-dashboard" :
                                                                    "/dashboard"
                                            }>
                                                <BsGrid /> Dashboard
                                            </a>


                                            <a className="dropdown-item memu-drop-item" onClick={() => { logout(); }} href="/"><BsPower /> Logout</a>
                                        </div>
                                    </div>
                                )
                        }
                        <div className="mobile-nav-toggle" onClick={toggle}>
                            <div className="menu-icon" style={{ display: 'block' }}>
                                <HiOutlineMenu />
                            </div>
                            <div className="close-icon" style={{ display: 'none' }}>
                                <MdClose />
                            </div>
                        </div>
                        <nav id="navbar" className="navbar">
                            <div className="nav-container">
                                <div className="row align-items-center">
                                    <div className="col-lg-6 width992_">
                                        <ul className="nav_menus">
                                            <li>
                                                <NavLink to="/club-fitting" activeClassName="active" className="">Club Fitting</NavLink>

                                            </li>
                                            <li className>
                                                <NavLink to="/golf-clubs" activeClassName="active" className="">Golf Clubs</NavLink>
                                            </li>
                                            {/* <li className>
                                                <NavLink to="/lessons" activeClassName="active" className="">Golf Lessons</NavLink>
                                            </li> */}
                                            <li className>
                                                <NavLink to="/about-us" exact activeClassName="active" className="">About us</NavLink>
                                            </li>
                                            <li className>
                                                <NavLink to="/fitter/fitter-locator" exact activeClassName="active" className="">Find a Fitter</NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-lg-6 nav_contact width992">
                                        <div className="gs_b gs_fr">
                                            <div className="gs_fr_top d-flex align-items-center justify-content-between me-0">
                                                <div className="gab_title">
                                                    <div className="gab_icon">
                                                        <img src={require('../../assets/images/005-call.png')} alt="" />
                                                    </div>
                                                    <div className="gab_text">
                                                        <h5>Phone</h5>
                                                    </div>
                                                </div>
                                                <a href="tel:(805) 650-1534" className="text-white c_action_link">(805) 650-1534</a>
                                            </div>
                                        </div>
                                        {/* <div className="gs_b gs_fr" onClick={
                                            () => {
                                                if (getCurrentUser() === null) {
                                                    handleShow()
                                                    toggle()
                                                } else {
                                                    window.location.href = "/Dashboard"
                                                }
                                            }
                                        }>
                                            <div className="gs_fr_top d-flex align-items-center justify-content-between me-0">
                                                <div className="gab_title">
                                                    <div className="gab_icon">
                                                        <FaFingerprint />
                                                    </div>
                                                    <div className="gab_text">
                                                        <h5>{getCurrentUser() === null ? "Login" : "Dashboard"}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="gs_b gs_fr">
                                            <div className="gs_fr_top d-flex align-items-center justify-content-between me-0">
                                                <div className="gab_title">
                                                    <div className="gab_icon">
                                                        <img src={require('../../assets/images/001-email.png')} alt="" />
                                                    </div>
                                                    <div className="gab_text">
                                                        <h5>Email</h5>
                                                    </div>
                                                </div>
                                                <a href="mailto:info@foreward.golf" className="text-white c_action_link">info@foreward.golf</a>
                                            </div>
                                        </div>
                                        <div className="gs_b gs_fr">
                                            <div className="gs_fr_top d-flex align-items-center justify-content-between me-0">
                                                <div className="gab_title">
                                                    <div className="gab_icon">
                                                        <img src={require('../../assets/images/003-globe.png')} alt="" />
                                                    </div>
                                                    <div className="gab_text">
                                                        <h5>Socials</h5>
                                                    </div>
                                                </div>
                                                <div className="p-0 width_35">
                                                    <a href="#" target="_blank" className="c_action_link text-white me-3"><i className="bi bi-facebook" /></a>
                                                    <a href="#" target="_blank" className="c_action_link text-white me-3"><i className="bi bi-instagram" /></a>
                                                    <a href="#" target="_blank" className="c_action_link text-white me-3"><i className="bi bi-youtube" /></a>
                                                    <a href="#" target="_blank" className="c_action_link text-white"><i className="bi bi-twitter" /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gs_b gs_fr">
                                            <div className="gs_fr_top d-flex align-items-center justify-content-between me-0">
                                                <div className="gab_title">
                                                    <div className="gab_icon">
                                                        <img src={require('../../assets/images/038-location.png')} alt="" />
                                                    </div>
                                                    <div className="gab_text">
                                                        <h5>Location</h5>
                                                    </div>
                                                </div>
                                                <span className="c_action_link text-success">
                                                    5917 Olivas Park Dr. Suite A<br />
                                                    Ventura, California 93003
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                        {/* .navbar */}
                    </div>
                </div>
            </header>

            <div id="menu-center" className={scrolling ? 'show_mobile mobile_header_view hidden' : 'show_mobile mobile_header_view'} style={{ zIndex: 999 }}>
                <ul className="nav nav_center mob-nav">
                    <li className>
                        <NavLink to="#" activeClassName="active" className="btn cen_men nav_club_fitting" onClick={showremotefittingpopup}>Book Your Fitting</NavLink>
                    </li>
                    <li className>
                        <NavLink to="#" activeClassName="active" className="btn cen_men nav_golf_lessons" onClick={handleShowfitter}>Become a Fitter</NavLink>
                    </li>
                    {/* <li className>
                        <NavLink to="/about-us" exact activeClassName="active" className="btn cen_men nav_footer">About us</NavLink>
                    </li> */}
                </ul>
            </div>

            <Modal centered show={showfitter} onHide={handleClosefitter} className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">Fitter Application</h3>
                            <button type="button" className="btn-close" onClick={handleClosefitter} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className='modal-long-form'>
                        <Form noValidate validated={validated} onSubmit={handleSubmit2}>
                            <div className="row gap-4">
                                <div className='row pe-0 gap-4' controlid="validationCustom011">
                                    <div className='col-md-6 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a first name.
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                    <div className='col-md-6 md-5 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last name" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a last name.
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom012">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={businessName} onChange={(e) => setBusinessName
                                                (e.target.value)} placeholder="Business Name" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a business name
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom013">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a phone number.
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom014">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="email" class="form-control dashboard-input-box-3" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a valid email address.
                                            </Form.Control.Feedback>
                                            {serverSideError && Array.isArray(serverSideError) && serverSideError.map((error, index) => (
                                                error.field === 'email' ? (
                                                    <div className="text-danger" key={index}>{error.message}</div>
                                                ) : null
                                            ))}

                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom015">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="https://example.com" />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a valid website URL.
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom016">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <textarea type="text" class="form-control dashboard-input-box-3" value={shippingAddress} onChange={(e) => setShippingAddress(e.target.value)} placeholder="Shipping Address" style={{ height: "100px" }} required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a shipping address.
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                                {/* country code */}

                                <div className='row pe-0 gap-4' controlid="validationCustom016">
                                    <div className='col-md-6 pe-0'>
                                        <div className='form-group-input'>
                                            <select name="country" value={country_id} onChange={(e) => {
                                                setCountry_id(e.target.value);
                                                setState_id(0);
                                                setCity_id(0);
                                                getallstatefunc(
                                                    e.target.value
                                                );
                                            }}
                                                class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                aria-label="Default select example"
                                                required
                                            >
                                                <option value={0}>
                                                    Country
                                                </option>
                                                {countrylist &&
                                                    countrylist.map(
                                                        (item) => (
                                                            <option
                                                                value={item._id}
                                                                key={item._id}
                                                            >
                                                                {item.name}
                                                            </option>
                                                        )
                                                    )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-md-6 md-5 pe-0'>
                                        <div className='form-group-input'>
                                            <select name="state" value={state_id} onChange={(e) => {
                                                setState_id(e.target.value)
                                                getallcityfunc(
                                                    e.target.value
                                                );
                                            }}
                                                class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                aria-label="Default select example"
                                                required
                                            >
                                                {stateLoading ? (
                                                    <option disabled>Loading...</option>
                                                ) : (
                                                    <>
                                                        <option value={0}>State</option>
                                                        {statelist &&
                                                            statelist.map((item) => (
                                                                <option value={item._id} key={item._id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0 gap-4' controlid="validationCustom016">
                                    <div className='col-md-6 pe-0'>
                                        <div className='form-group-input'>
                                            <select name="city" value={city_id} onChange={(e) => { setCity_id(e.target.value); }}
                                                class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required>
                                                {cityLoading ? (
                                                    <option disabled>Loading...</option>
                                                ) : (
                                                    <>
                                                        <option value={0}>City/Town</option>
                                                        {citylist &&
                                                            citylist.map((item) => (
                                                                <option value={item._id} key={item._id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-md-6 md-5 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={zipcode} onChange={(e) => setzipcode(e.target.value)} placeholder="Zip code" required />
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom016">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <textarea type="text" class="form-control dashboard-input-box-3" value={bio} onChange={(e) => setbio(e.target.value)} placeholder="Bio..." style={{ height: "100px" }} />
                                        </div>
                                    </div>
                                </div>

                                <div className='row pe-0'>
                                    <div className='full-width-btn pe-0'>
                                        <>
                                            {
                                                apiCallNew ? (
                                                    <button className="btn btn_default text-dark btn_disabled" type="submit" disabled>
                                                        <span>...Submit Fitter Application</span>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn_default text-dark btn_disabled" type="submit">
                                                        <span>Submit Fitter Application</span>
                                                    </button>
                                                )
                                            }

                                            {/* <button className="btn btn_default text-dark btn_disabled" type="submit">Submit Fitter Application</button> */}
                                        </>
                                    </div>
                                </div>
                            </div>
                        </Form>

                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={show02}
                onHide={handleClose02}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose02} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../assets/images/forewardFormSubmit.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your message is sent!
                    </h3>
                    <p className="text-center mb-0">
                        Our staff will be in contact shortly to answer any questions and get you sorted.
                    </p>
                </Modal.Body>
            </Modal>

            <Modal
                show={show2}
                onHide={handleClose2}
                centered
                id="success_tic"
                className="center-form-modal"
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <h3 className="text mb-5">How can we help?</h3>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose2} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <SupportPopup subject="about us" onHideForm={(formHide) => setShow2(formHide)} onShowForm={(formShow) => handleShowForm(formShow)} />
                </Modal.Body>
            </Modal>

            <Modal show={show} onHide={handleClose} centered className="header-login-modal">
                {/* <Modal.Header>
                    <div className="modal-nav">
                        <div className="modal-logo">
                            <img src={Popuplogo} alt="logo" />
                        </div>
                    </div>
                </Modal.Header> */}
                <Modal.Body className="modal-body2">
                    <div className="custom-modal-header">
                        <div className="modal-tltle">Sign in to your Account</div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className="form-section modal-form-section">
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Form.Group className="mb-4" controlId="validationCustom01">
                                <Form.Label className="custom-lable">Email address</Form.Label>
                                <Form.Control
                                    required
                                    type="email"
                                    placeholder="Enter email"
                                    className={`custom-input  ${errors.length > 0 ? getErrorByField(errors, "email").length > 0 ? "is-invalid" : "" : ""}`}
                                    value={email} onChange={(e) => setEmail(e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {
                                        errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                            return item.message;
                                        }) : "Please enter valid email"
                                    }
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-4" controlId="validationCustom02">
                                <Form.Label className="custom-lable">Password</Form.Label>
                                <Form.Control
                                    required
                                    type="password"
                                    placeholder="Password"
                                    className={`custom-input  ${errors.length > 0 ? getErrorByField(errors, "password").length > 0 ? "is-invalid" : "" : ""}`}
                                    value={password} onChange={(e) => setPassword(e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {
                                        errors.length > 0 ? getErrorByField(errors, "password").map((item) => {
                                            return item.message;
                                        }) : "Please enter your password"
                                    }
                                </Form.Control.Feedback>
                            </Form.Group>
                            {
                                apicall ?
                                    <Button className="Login-btn-view disable">
                                        <Spinner animation="border" className="border-light" />
                                    </Button> :
                                    <Button className="Login-btn-view" type="submit">
                                        Submit
                                    </Button>

                            }
                        </Form>


                        <div className="cantaccess"><b><span>Can't access your account?</span></b></div>
                        <div className="lowbuttons row">
                            <div className="col-md-7">
                                <button className="forgot-btn" onClick={() => { handleShow03(); handleClose() }}>
                                    <a href="#"><b>Forgot Password</b></a>
                                </button>
                            </div>
                            <div className="col-md-5">
                                <button className="email-btn" onClick={handleShow2}>
                                    <a href="#"><b>Email Us</b></a>
                                </button>
                            </div>
                        </div>


                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={show03} onHide={handleClose03} centered className="header-login-modal">
                {/* <Modal.Header>
                    <div className="modal-nav">
                        <div className="modal-logo">
                            <img src={Popuplogo} alt="logo" />
                        </div>
                    </div>
                </Modal.Header> */}
                <Modal.Body className="modal-body2">
                    <div className="custom-modal-header">
                        <div className="modal-tltle">Forgot your password</div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose03} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className="form-section modal-form-section">
                        <Form noValidate validated={validated} onSubmit={forgetpassword}>
                            <Form.Group className="mb-2" controlId="validationCustom01">
                                <Form.Label className="custom-lable">Email address</Form.Label>
                                <Form.Control
                                    required
                                    type="email"
                                    placeholder="Enter email"
                                    className={`custom-input  ${errors.length > 0 ? getErrorByField(errors, "email").length > 0 ? "is-invalid" : "" : ""}`}
                                    value={email} onChange={(e) => { setEmail(e.target.value); setErrors([]); setSuccessmsg('') }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {
                                        errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                            return item.message;
                                        }) : "Please enter valid email"
                                    }
                                </Form.Control.Feedback>
                            </Form.Group>
                            <div style={{ color: 'green' }} className="mb-2">{successmsg}
                            </div>

                            {
                                apicall ?

                                    <Button className="Login-btn-view disable">
                                        <Spinner animation="border" className="border-green" />
                                    </Button> :
                                    <Button className="Login-btn-view" type="submit">
                                        Submit
                                    </Button>

                            }
                        </Form>


                        <div className="cantaccess"><b><span>Sign in or contact us</span></b></div>
                        <div className="lowbuttons row">
                            <div className="col-md-7 col-sm-7">
                                <button className="forgot-btn" onClick={() => { handleShow(); handleClose03() }}>
                                    <a href="#"><b>Sign in</b></a>
                                </button>
                            </div>
                            <div className="col-md-5 col-sm-5">
                                <button className="email-btn" onClick={handleShow2}>
                                    <a href="#"><b>Email Us</b></a>
                                </button>
                            </div>
                        </div>


                    </div>
                </Modal.Body>
            </Modal>
            <style>
                {`
                    @media only screen and (max-width: 768px) {
                        .modal-dialog{
                            margin: 0 !important;
                        }
                    }
                `}
            </style>
        </>
    );
}

export default Header;